import { negotiateLanguagePreferences } from '../../../../../paraglide-js/dist/adapter-utils/index.js';
import { ACCEPT_LANGUAGE_HEADER_NAME } from '../../constants.js';

const createAcceptLanguageDetection = (cfg) => (request) => {
    const acceptLanguage = request.headers.get(ACCEPT_LANGUAGE_HEADER_NAME);
    const preferences = negotiateLanguagePreferences(acceptLanguage, cfg.availableLanguageTags);
    return preferences.at(0);
};

export { createAcceptLanguageDetection };
